import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalTitle: {
        "&.MuiTypography-root": {
            fontFamily: "Source Sans 3",
            fontWeight: 400,
            fontSize: "18px",
            color: theme.palette.info.main,
            padding: "10px 30px",
            borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        },
    },
    bodyContainer: {
        overflowY: "auto",
        maxHeight: "70vh",
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "410px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    padding: 0,
    borderRadius: "4px",
};
